import ApplicationElement from '@effectivastudio/lit-components/components/application_element/element.js';
import reset from './reset.lit.css';
import dotMenu from './dot_menu.lit.css';
import buttons from './../assets/stylesheets/elements/_buttons_v1.lit.css';

ApplicationElement.styles.push(reset, dotMenu, buttons);
